import React from 'react';
import * as home from '../../components/home';
import MainHome from '../../components/carousel/MainHome';
import { useSelector } from 'react-redux';

const VendorHome = () => {
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  return (
    <div className='mt-3 md:mt-5 flex flex-col gap-5'>
      <MainHome />
      <home.ShopCardsSection />
      <home.PopularProducts />
      <home.ProductBanner />
      {/* <home.GreatSavingsSection /> */}
      {isAuthenticated && <home.BlockbusterDeals />}
      {/* <home.Shortlist /> */}
    </div>
  )
}

export default VendorHome;